import { Moon, Sun } from 'lucide-react'
import { useUIStore } from '@/stores/useUIStore'

/**
 * Icon-only light/dark theme toggle for the top header.
 */
export function ThemeToggleButton(): React.ReactElement {
  const theme = useUIStore((s) => s.theme)
  const setTheme = useUIStore((s) => s.setTheme)
  const isDark = theme === 'dark'
  const nextTheme = isDark ? 'light' : 'dark'

  return (
    <button
      type="button"
      onClick={() => setTheme(nextTheme)}
      className="rounded-xl p-2 text-gray-400 transition-colors hover:bg-gray-100/80 hover:text-gray-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 dark:text-gray-500 dark:hover:bg-white/5 dark:hover:text-gray-300"
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {isDark ? (
        <Sun className="h-5 w-5 shrink-0" aria-hidden />
      ) : (
        <Moon className="h-5 w-5 shrink-0" aria-hidden />
      )}
    </button>
  )
}

ThemeToggleButton.displayName = 'ThemeToggleButton'
